module.exports = __webpack_public_path__ + "static/img/icon-overview1.591de2d8.svg";